export default "__VITE_ASSET__13cf2536__"